// A flame after a channel's name in the list (#58): one of the busiest channels since you last read it. It takes the
// unread dot's place; a dot means new messages, a flame means a lot of them.
export function Flame({ count }: { count?: number }) {
  const label = count === undefined ? "Busy" : `Busy: ${count} new message${count === 1 ? "" : "s"}`;
  return (
    // An outline with a light core (FR: "a little less dense"), so it reads as a mark, not a blob.
    <svg className="flame" viewBox="0 0 12 14" width="11" height="13" role="img" aria-label={label}>
      <title>{label}</title>
      <path className="flame-core" d="M6 8.2c.9.6 1.4 1.3 1.4 2.1a1.4 1.4 0 0 1-2.8 0c0-.8.5-1.4 1.4-2.1z" />
      <path className="flame-edge" d="M6.2 1.2c.3 1.7-.5 2.8-1.4 3.8C3.7 6.1 2.6 7.3 2.6 9a3.4 3.4 0 0 0 6.8 0c0-1.4-.6-2.5-1.4-3.3.1 1-.3 1.7-1 2 .2-2.5-.6-4.7-.8-6.5z" />
    </svg>
  );
}
